


























































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../Streamax/fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormCenterSetHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: '' }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  hora: any;
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraCenterSetHowen'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.protocol.value = parseInt(this.data['?column?'].protocol1);
    this.formFields.protocol.value1 = parseInt(this.data['?column?'].protocol2);
    this.formFields.protocol.value2 = parseInt(this.data['?column?'].protocol3);
    this.formFields.protocol.value3 = parseInt(this.data['?column?'].protocol4);
    this.formFields.gpsInterval1.value = this.data['?column?'].gpsinterval1;
    this.formFields.gpsInterval2.value = this.data['?column?'].gpsinterval2;
    this.formFields.gpsInterval3.value = this.data['?column?'].gpsInterval;
    this.formFields.gpsInterval4.value = this.data['?column?'].gpsInterval;
    this.formFields.server1.value = this.data['server'].server0.mainip;
    this.formFields.server2.value = this.data['server'].server1.mainip;
    this.formFields.server3.value = this.data['server'].server2.mainip;
    this.formFields.server4.value = this.data['server'].server3.mainip;
    this.formFields.serverPort1.value = this.data['server'].server0.mainport;
    this.formFields.serverPort2.value = this.data['server'].server1.mainport;
    this.formFields.serverPort3.value = this.data['server'].server2.mainport;
    this.formFields.serverPort4.value = this.data['server'].server3.mainport;
  }
  mounted() {
    this.getTime();
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  onSelectionChanged(params: any) {}
  formFields: {
    protocol: any;
    protocol2: any;
    gpsInterval1: any;
    gpsInterval2: any;
    gpsInterval3: any;
    gpsInterval4: any;
    server1: any;
    server2: any;
    server3: any;
    server4: any;
    serverPort1: any;
    serverPort2: any;
    serverPort3: any;
    serverPort4: any;
  } = {
    protocol: {
      label: 'Protocol',
      value: 0,
      value1: 0,
      value2: 0,
      value3: 0,
      items: [
        { label: 'OFF', id: 0 },
        { label: 'T', id: 1 },
        { label: 'H', id: 2 },
        { label: 'Bubiao protocol', id: 4 },
      ],
    },
    protocol2: {
      label: 'Protocol 2',
      value: 0,
      items: [{ label: 'OFF', id: 0 }, { label: 'H', id: 2 }],
    },
    gpsInterval1: {
      label: 'GPS Report Interval',
      value: '',
    },
    gpsInterval2: {
      label: 'GPS Report Interval',
      value: '',
    },
    gpsInterval3: {
      label: 'GPS Report Interval',
      value: '',
    },
    gpsInterval4: {
      label: 'GPS Report Interval',
      value: '',
    },
    server1: {
      label: 'Server 1',
      value: '',
    },
    server2: {
      label: 'Server 2',
      value: '',
    },
    server3: {
      label: 'Server 3',
      value: '',
    },
    server4: {
      label: 'Server 4',
      value: '',
    },
    serverPort1: {
      label: 'Port 1',
      value: '',
    },
    serverPort2: {
      label: 'Port 2',
      value: '',
    },
    serverPort3: {
      label: 'Port 3',
      value: '',
    },
    serverPort4: {
      label: 'Port 4',
      value: '',
    },
  };
  selectedProtocol() {
    return this.formFields.protocol.items.find(
      (item: { id: any }) => item.id === this.formFields.protocol.value
    );
  }
  selectedProtocol2() {
    return this.formFields.protocol2.items.find(
      (item: { id: any }) => item.id === this.formFields.protocol2.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  datoEditado: any = {};
  grabarEdicion(val: boolean) {
    if (val) {
      this.datoEditado.server1mainip = this.formFields.server2.value;
      this.datoEditado.server1mainport = this.formFields.serverPort2.value;
      if (!this.datoEditado.server1mainip.length) {
        this.$snotify.error('El server 2 No puede estar vacio', {
          timeout: 3000,
        });
        this.confirmCallbackConfirm(false);
        return;
      }
      if (!this.datoEditado.server1mainport.length) {
        this.$snotify.error('El port 2 No puede estar vacio', {
          timeout: 3000,
        });
        this.confirmCallbackConfirm(false);
        return;
      }
      console.log(JSON.stringify(this.datoEditado));
      this.editar();
    }
    this.confirmCallbackConfirm(false);
  }
  async editar() {
    let self = this;
    return fetchConfiguracionStreamax(
      {
        server: JSON.stringify(this.datoEditado),
        id_camara: this.selectedValue,
        usuario: this.usuario,
      },
      'configCamaras/saveConfServer'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualizacion exitosa', { timeout: 3000 });
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
    /* .finally(() => {
            return null;
          }); */
  }
  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }
  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
  confirmCallback(val: any) {}
  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = val;
  }
}
